// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2Cv4j","footer":"ReportModalFilter_footer__3f5-V"};